import { render, staticRenderFns } from "./CPICPayment.vue?vue&type=template&id=87d051b8&scoped=true&"
import script from "./CPICPayment.vue?vue&type=script&lang=js&"
export * from "./CPICPayment.vue?vue&type=script&lang=js&"
import style0 from "./CPICPayment.vue?vue&type=style&index=0&id=87d051b8&lang=less&scoped=true&"
import style1 from "./CPICPayment.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d051b8",
  null
  
)

export default component.exports